import { useCallback, useEffect, useState } from "react";
import { FullAddress } from "../../../common/types/interfaces";

interface Params {
  initialData: FullAddress;
  onSubmit: (data: FullAddress) => Promise<void> | void;
  onCancel?: () => void;
}

export const useAddressForm = ({ initialData, onSubmit, onCancel }: Params) => {
  const [data, setData] = useState<FullAddress>(initialData);
  const [addressNotValid, setAddressNotValid] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setData(initialData);
  }, [initialData]);

  useEffect(() => {
    const valid = Boolean(
      data.address.value && data.address.latitude && data.address.longitude,
    );
    setAddressNotValid(!valid);
  }, [data]);

  const inputHandler = useCallback(
    (value: string, field: keyof FullAddress) => {
      setError(null);
      setData((prev) => ({ ...prev, [field]: value }));
    },
    [],
  );

  const formAction = useCallback(async () => {
    if (addressNotValid) {
      setError("Выберите адрес из списка");
      return;
    }

    setError(null);

    const { isDirty: _addressDirty, ...address } = data.address;
    const { isDirty: _cityDirty, ...city } = data.city;

    const payload: FullAddress = {
      name: data.name?.trim() || "",
      description: data.description?.trim() || undefined,
      isGeneral: !!data.isGeneral,
      entrance: data.entrance?.trim() || undefined,
      floor: data.floor?.trim() || undefined,
      apartment: data.apartment?.trim() || undefined,
      intercom: data.intercom?.trim() || undefined,
      address,
      city,
    };

    try {
      await onSubmit(payload);
    } catch {
      setError("Не удалось сохранить адрес");
    }
  }, [data, addressNotValid, onSubmit]);

  const closeForm = useCallback(() => {
    setError(null);
    onCancel?.();
  }, [onCancel]);

  return {
    data,
    setData,
    inputHandler,
    addressNotValid,
    formAction,
    closeForm,
    error,
  };
};
